import type { FormikProps } from 'formik';

import './CustomerLeadStepSalesTaxInfo.scss';

import { YesNoSelectField } from 'src/components/base/fields/YesNoSelectField';
import type { ICustomerLeadSalesTaxInfoTabFormValues } from 'src/components/customers/CustomerLeadTypes';
import { CustomerLeadStepSalesTaxFilesList } from 'src/components/customers/steps/Contact/CustomerLeadStepSalesTaxFilesList';
import { CustomerLeadStepLayoutNextButton } from 'src/components/customers/steps/CustomerLeadStepLayoutNextButton';
import { useDebounceEffect } from 'src/hooks/useDebounceEffect';

type CustomerLeadStepSalesTaxInfoTabContentProps = {
  formikProps: FormikProps<ICustomerLeadSalesTaxInfoTabFormValues>;

  onUpdate: (newValues: Omit<ICustomerLeadSalesTaxInfoTabFormValues, 'salesTaxFiles'>) => void;
};

export function CustomerLeadStepSalesTaxInfoTabContent({
  formikProps: { values, validateForm },
  onUpdate,
}: Readonly<CustomerLeadStepSalesTaxInfoTabContentProps>) {
  useDebounceEffect(
    () => {
      void (async () => {
        const errors = await validateForm(values);

        const errorCount = Object.keys(errors).length;

        if (errorCount === 0 || (errorCount === 1 && !!errors.salesTaxFiles)) {
          onUpdate({
            exempt: values.exempt,
          });
        }
      })();
    },
    [values.exempt],
    1000
  );

  return (
    <div className="customer-lead-step-sales-tax-info__container">
      <div className="customer-lead-step-sales-tax-info__container__row">
        <YesNoSelectField name="exempt" label="Exempt?" description="" />
      </div>

      <CustomerLeadStepSalesTaxFilesList />

      <div className="customer-lead-step__layout__center__footer-actions">
        <CustomerLeadStepLayoutNextButton />
      </div>
    </div>
  );
}
